const data = [
  {
    id: "dashboard",
    icon: "iconsminds-check",
    label: "Dashboard",
    to: `/app/dashboard`,
    access: ["Admin", "Dekanat", "Tutor", "Foydalanuvchi"],
  },
  {
    id: "students",
    icon: "iconsminds-student-hat",
    label: "Talabalar",
    to: `/app/students`,
    access: ["Admin", "Dekanat", "Tutor", "Foydalanuvchi"],
  },
  {
    id: "payments",
    icon: "iconsminds-printer",
    label: "To'lovlar",
    to: `/app/payments`,
    access: ["Admin", "Tutor", "Dekanat", "Foydalanuvchi"],
  },
  {
    id: "contracts",
    icon: "iconsminds-files",
    label: "Shartnomalar",
    to: `/app/contracts`,
    access: ["Admin", "Tutor", "Dekanat", "Foydalanuvchi"],
  },
  {
    id: "users",
    icon: "iconsminds-conference",
    label: "Foydalanuvchilar",
    to: `/app/users`,
    access: ["Admin"],
  },
];
export default data;
